import { render, staticRenderFns } from "./ShopDetails.vue?vue&type=template&id=d92305de&scoped=true&"
import script from "./ShopDetails.vue?vue&type=script&lang=js&"
export * from "./ShopDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92305de",
  null
  
)

export default component.exports